import React from "react";
import * as Material from "@mui/material";
import { IconBuildingBank } from "@tabler/icons-react";

import styles from "./styles.scss";

import { Text, Button } from "@fragments";
import StatusChip from "@fragments/StatusChip";
import banks from "@helpers/banks";
// import api from "@helpers/api.js";
import Parser from "@helpers/parser.js";

export default function ConnectedAccount({ wallet, loading, onRegisterAccount }) {

    return (
        <div className="withdrawals-connected-account mt-3 mb-5">
            <Text.h4 weight={300} contrast={9} className="mb-1">
                Conta conectada para saques
            </Text.h4>

            {loading ? (
                <Loading />
            ) : (
                <Card wallet={wallet} onRegisterAccount={onRegisterAccount} />
            )}
        </div>
    )
}

const Card = ({ wallet, onRegisterAccount }) => {
    if (!wallet?.withdrawal) {
        return (
            <div className="connected-account-card px-3 py-2" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: '72px' }}>
                <Text.span contrast={6} weight={500}>Conta de recebíveis não cadastrada</Text.span>
                <Button text="Cadastrar conta" onClick={onRegisterAccount} size="small" />
            </div>
        )
    }

    const { withdrawal, statuses } = wallet;
    const { receiver } = withdrawal;

    const bankConfig = banks.find(b => parseInt(b.code) === parseInt(receiver?.bank?.code));
    const bankLogo = bankConfig?.logo || receiver?.bank?.logo;

    const statusConfig = {
        'approved': { text: 'Ativa', variant: 'success' },
        'active': { text: 'Ativa', variant: 'success' },
        'pending': { text: 'Pendente', variant: 'alert' },
        'rejected': { text: 'Reprovada', variant: 'error' },
        'processing': { text: 'Processando', variant: 'info' }
    }[statuses?.bank] || { text: statuses?.bank || 'Desconhecido', variant: 'default' };

    const keyTypeMap = {
        'phone': 'Celular',
        'email': 'E-mail',
        'document': 'CPF/CNPJ',
        'random': 'Chave Aleatória'
    };

    let keyFormatted = withdrawal.key;
    if (withdrawal.keyType === 'email') {
        keyFormatted = Parser.email(withdrawal.key);
    } else if (withdrawal.keyType === 'phone') {
        keyFormatted = Parser.phone('+55' + withdrawal.key);
    } else if (withdrawal.keyType === 'cpf') {
        keyFormatted = Parser.cpf(withdrawal.key);
    } else if (withdrawal.keyType === 'cnpj') {
        keyFormatted = Parser.cnpj(withdrawal.key);
    }

    return (
        <div className="connected-account-card">
            <div className="left-section">
                {bankLogo ? (
                    <img
                        src={bankLogo}
                        alt={receiver.bank.name}
                        className="bank-logo"
                    />
                ) : (
                    <IconBuildingBank className="bank-fallback-icon" />
                )}
            </div>

            <div className="right-section">
                <div className="info-row">
                    <Text.span contrast={7}>
                        <Text.span weight={500} contrast={7}>Chave pix: </Text.span>
                        {keyFormatted}
                    </Text.span>

                    <StatusChip text={statusConfig.text} variant={statusConfig.variant} />
                </div>

                <Text.span className="info-row" contrast={7}>
                    {receiver?.owner?.name} {receiver?.owner?.document}
                </Text.span>
            </div>
        </div>
    )
}


const Loading = () => {
    const skeletonSx = {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        '&::after': {
            background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)'
        }
    };

    return (
        <div className="connected-account-card mt-1">
            <Material.Skeleton
                variant="rounded"
                width={56}
                height={56}
                sx={skeletonSx}
            />
            <div className="right-section" style={{ gap: '8px' }}>
                <Material.Skeleton
                    variant="rounded"
                    width={100}
                    height={24}
                    sx={skeletonSx}
                />
                <Material.Skeleton
                    variant="text"
                    width={200}
                    height={20}
                    sx={skeletonSx}
                />
            </div>
        </div>
    )
}